module.exports = __webpack_public_path__ + "static/img/5_2.19a511b4.jpg";